<template lang="pug">
	.user-profile
		.page-center-content(v-if="user && publisher")
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") {{user.name}} Profile
				.logo
					img(:src="Publisher.getLogoUrl(publisher)" :alt="publisher.title")
			.settings-groups-area
				.settings-section
					.settings-group.photo
						.user-photo(:style="{ backgroundImage: `url(${User.getPhotoUrl(user)})` }")
					.settings-group
						.form-group.user-name
							label Name
							input.form-control(type="text" :value="user.name" @input="saveName($event.target.value)")
					.settings-group
						.form-group
							label Email
							input.form-control(type="text" :value="user.email" disabled)
					.settings-group
						.form-group
							label Photo
							br
							button.btn.btn-secondary(type="button" @click="replacePhoto")
								.icon.fa.fa-upload
								span &nbsp;&nbsp;Upload new photo
					.settings-group(:style="{width: '100px'}")
						.form-group
							label Enabled
							br
							label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{marginTop: '5px'}")
								input.switch-input.form-check-input(type="checkbox" :checked="user.active" @change="activateUser(user, $event.target.checked)" :disabled="!(User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])) || user.isAdmin")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
					.settings-group(:style="{width: '100px', visibility: user.active ? 'hidden' : 'visible'}")
						.form-group
							button.btn.btn-sm.btn-danger(v-if="!user.Tags.deleted" type="button" @click="deleteUser(user)" :style="{marginTop: '7px'}" :disabled="!(User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])) || !!user.active")
								.icon.fa.fa-remove
								span Delete
							button.btn.btn-sm.btn-secondary(v-if="user.Tags.deleted" type="button" @click="deleteUserRevert(user)" :style="{marginTop: '7px'}" :disabled="!(User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])) || !!user.active")
								.icon.fa.fa-plus
								span Revert
				.settings-section.subcaption(v-if="User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])")
					label.no-margin Company
					.description.text-muted
						span The Developer and Manager roles are used just for the information about user and will not affect the Dashboard viewability or functions. The Company admin role have possibility to invite, deactivate and delete other users, and change their roles.
					.columns-3
						.column(v-if="User.currentUser.isAdmin")
							.form-group
								label Company
								select.custom-select.form-control(:value="user['publisher_id']" @change="changePublisher($event.target, $event.target.value)" :disabled="!User.currentUser.isAdmin")
									option(v-for="publisher in Publisher.getAllPublishers()" v-if="publisher.active || (publisher.id === user['publisher_id'])" :value="publisher.id") {{publisher.title}}
						.column
							.form-group
								label Role
								select.custom-select.form-control(:value="user.role" @change="changeRole($event.target.value)" :disabled="!(User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin']))")
									option(value="developer") Developer
									option(value="manager") Manager
									option(value="publisher-admin") Company admin
						.column(v-if="User.currentUser.isAdmin && Layout.isFeatureEnabled('user-switch')")
							.form-group
								label Login as this user
								button.btn.btn-outline-primary(type="button" @click="loginUser(user)")
									.icon.fa.fa-login
									span Login
						//.column(v-if="User.currentUser.Tags['super-admin']")
							.form-group
								button.btn.btn-primary(@click="showAccess()")
									.icon.fa.fa-shield
									| &nbsp;&nbsp;Access
				.settings-section.subcaption
					label.no-margin Online users
					.description.text-muted
						span Enable this feature to see your company online users
					.columns-5
						.column
							.form-group
								label Show online users
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" v-model="features['online-users']" v-on:change="User.toggleFeature(user.id, 'online-users', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="User.currentUser.isAdmin && features['online-users']")
							.form-group
								label Over publisher list
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['online-users-publisher-list']" v-on:change="User.toggleFeature(user.id, 'online-users-publisher-list', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="User.currentUser.isAdmin && features['online-users']")
							.form-group
								label Publisher list colors
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['online-users-publisher-color']" v-on:change="User.toggleFeature(user.id, 'online-users-publisher-color', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="features['online-users']")
							.form-group
								label Over creative list
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['online-users-project-plane']" v-on:change="User.toggleFeature(user.id, 'online-users-project-plane', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="features['online-users']")
							.form-group
								label Over version list
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['online-users-version-plane']" v-on:change="User.toggleFeature(user.id, 'online-users-version-plane', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
				.settings-section.subcaption(v-if="user.id === User.currentUser.id || User.currentUser.isAdmin || (User.currentUser['publisher_id'] === user['publisher_id'] && User.currentUser.Tags['publisher-admin'])")
					label.no-margin Editor
					.description.text-muted
						span When you drop an asset into the frame on the scene, a new element is created - the dashboard opens the elements editor and selects the new element so you can move it right away
					.columns-3
						.column
							.form-group
								label Open editor on asset drop
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="features['editor-open-on-frame-drop'] !== false" v-on:change="User.toggleFeature(user.id, 'editor-open-on-frame-drop', $event.target.checked)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
				//- Голосовой ввод в ИИ чате: обучение модели ключевых фраз (только для своего профиля - модели хранятся в таблице user_voices)
				.settings-section.subcaption(v-if="user.id === User.currentUser.id")
					label.no-margin AI chat voice activation
					.description.text-muted
						span Record your own start and stop phrases to control voice input in the AI chat without touching the keyboard. {{selectedVoiceModel ? `Selected voice model trained ${new Date(selectedVoiceModel.date).toLocaleString()}.` : 'Voice model is not trained yet.'}}
					.columns-3
						.column
							.form-group
								button.btn.btn-primary(type="button" @click="showVoiceTraining()")
									.icon.fa.fa-microphone
									span &nbsp;&nbsp;{{selectedVoiceModel ? 'Voice activation training' : 'Set up voice activation'}}
				//- ИИ настройки пользователя (бюджет ИИ и история изменений)
				.settings-section.subcaption
					label.no-margin User AI settings
					.description.text-muted
						span Manage user AI budget and view budget history.
					.columns-3
						.column
							.form-group
								button.btn.btn-primary(type="button" @click="showUserAISettings()")
									.icon.fa.fa-magic
									span &nbsp;&nbsp;User AI settings
				.settings-section.access(v-if="User.currentUser.Tags['super-admin'] && user.Tags['admin']")
					label Access
					.description
					.columns-3
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="access in accesses[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="user.options?.access?.[access.codename]" v-on:change="changeAccessStatus(access.codename, $event.target.checked)")
									|{{access.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="access in accesses[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="user.options?.access?.[access.codename]" v-on:change="changeAccessStatus(access.codename, $event.target.checked)")
									|{{access.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="access in accesses[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="user.options?.access?.[access.codename]" v-on:change="changeAccessStatus(access.codename, $event.target.checked)")
									|{{access.title}}
				.settings-section.publishers-access(v-if="User.currentUser.Tags['super-admin'] && user.Tags['admin']")
					label Company access
					.description.text-muted
						span Companies that administrator «{{user.name}}» sees
					.columns-3(v-if="user.options?.access?.['publishers-full-access']")
						.description.text-muted
							span.color-green This user have access to all publishers
					.columns-3(v-else-if="accessPublishers[0].length === 0")
						.description.text-muted
							span There are no access to any company. You can add access to any company for the user «{{user.name}}» on «Company settings» screen
					.columns-3(v-else)
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="publisherId in accessPublishers[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!!user.options?.access?.publishers?.[publisherId]" v-on:change="changeMraidioPublisherAccess(parseInt(publisherId), $event.target.checked)")
									|{{Publisher.getPublisher(publisherId)?.title || 'unknown'}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="publisherId in accessPublishers[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!!user.options?.access?.publishers?.[publisherId]" v-on:change="changeMraidioPublisherAccess(parseInt(publisherId), $event.target.checked)")
									|{{Publisher.getPublisher(publisherId)?.title || 'unknown'}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="publisherId in accessPublishers[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!!user.options?.access?.publishers?.[publisherId]" v-on:change="changeMraidioPublisherAccess(parseInt(publisherId), $event.target.checked)")
									|{{Publisher.getPublisher(publisherId)?.title || 'unknown'}}
				.settings-section.creatives-access(v-if="User.currentUser.Tags['super-admin'] && user.Tags['admin']")
					label Creatives access
					.description.text-muted
						span Creatives that administrator «{{user.name}}» sees
					.columns-3(v-if="user.options?.access?.['projects-full-access']")
						.description.text-muted
							span.color-green This user have access to all creatives
					.columns-3(v-else-if="accessCreatives[0].length === 0")
						.description.text-muted
							span There are no access to any creative. You can add access to any creative for the user «{{user.name}}» on «Creative settings» screen
					.columns-3(v-else)
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="creativeId in accessCreatives[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!!user.options?.access?.projects?.[creativeId]" v-on:change="changeMraidioCreativeAccess(parseInt(creativeId), $event.target.checked)")
									|{{Creative.getCreative(creativeId)?.title || 'unknown'}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="creativeId in accessCreatives[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!!user.options?.access?.projects?.[creativeId]" v-on:change="changeMraidioCreativeAccess(parseInt(creativeId), $event.target.checked)")
									|{{Creative.getCreative(creativeId)?.title || 'unknown'}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="creativeId in accessCreatives[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!!user.options?.access?.projects?.[creativeId]" v-on:change="changeMraidioCreativeAccess(parseInt(creativeId), $event.target.checked)")
									|{{Creative.getCreative(creativeId)?.title || 'unknown'}}
				.settings-section.subcaption(v-if="user.id === User.currentUser.id || User.currentUser.Tags['publisher-admin']" style="position: relative; padding: 0;")
					.detailed-log-button
						button.btn.btn-primary(@click="Layout.setPage('user-actions-log', {userId: user.id, backPage: ['user-profile', {userId: user.id}]})")
							.icon.fa.fa-list-alt
							| &nbsp;&nbsp;Detailed log
					div(style="padding: 0 1rem")
						label.no-margin Last user actions log
						.description.text-muted
							span Only important actions are shown here. To view all actions, click on "Detailed log".
					.actions-data-table
						DataTable(name="user-profile-log" entity="monitoring_actions" :fields="fields" :filters="filters" :buttons="buttons" key-field="id" :sort="['date', 'desc']" :update-on="['Layout Page Showed:user-profile']" :update-if="() => Layout.page === 'user-profile'" :entries-count="'25'" :header="false" :footer="false")

</template>

<script>
	import Screen 				from './../../mixins/screen'
	import { Auth } from "../../services/Auth";

	import { AIAgent } 			from './../../services/AIAgent'
	import { Layout } 			from './../../services/Layout'
	import { Publisher } 		from './../../services/Publisher'
	import { User } 			from './../../services/User'

	import DataTable			from './../../components/Templates/DataTable'

	import SetupSettings 		from "./../../settings/settings.json";

	export default {
		name: "UserProfile",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Publisher Changed",
				"Creatives Loaded",
				"Current User Changed",
				"Layout Page Showed:user-profile",
				"Current User Changed: [options.features]",
				"AI Chat Voice Models Changed",
				"User Changed"
			]
		},
		components: {
			DataTable
		},
		data() {

			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: false,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '70px'
				},
				{
					fieldName: 'date',
					title: 'Date',
					type: 'date',
					class: 'date-only',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '100px'
				},
				{
					fieldName: 'type',
					title: 'Log type',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'title',
					title: 'Title',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '250px'
				},
				{
					fieldName: 'description',
					title: 'Description',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false
				}
			];

			this.filters = [];

			this.buttons = [];

			this.user = null;
			this.publisher = null;

			// Выбранная модель голосового ввода ИИ чата
			this.selectedVoiceModel = null;

			this.accesses = [[], [], []];
			this.accessPublishers = [[], [], []];
			this.accessCreatives = [[], [], []];

			this.features = {};

			return {
				showed: true,
				userId: null,
				onlineUsers: true
			};

		},
		methods: {
			collectData(reason) {

				if (Layout.page === 'user-profile' && Layout.pageOptions?.userId) {

					this.userId = Layout.pageOptions.userId;

				} else if (User.currentUser) {

					this.userId = User.currentUser.id;

				} else {

					this.userId = null;

				}

				if (reason === 'Layout Page Showed:user-profile') {

					Server.sendToServer({
						GetUserProfile: this.userId
					});

				}

				this.user = User.getUser(this.userId);

				this.selectedVoiceModel = AIAgent.getSelectedVoiceModel();

				this.publisher = Publisher.getPublisher(this.user?.['publisher_id']);

				if (this.user) {

					this.filters.length = 0;

					this.filters.push({
						title: 'User',
						field: 'user_id',
						type: 'equal',
						value: this.user.id,
						display: false
					});

					this.filters.push({
						title: 'Type',
						field: 'type',
						type: 'not:in',
						value: ['navigation', 'availability'],
						display: false
					});

					this.features = _.clone(this.user?.options?.['features'] || {});

					this.onlineUsers = !!this.features['online-users'];

					let accesses = _.orderBy(_.filter(_.values(Metadata.Access), access => access.type === 'boolean'), 'priority');
					let partLength = Math.ceil(accesses.length / 3);

					this.accesses[0] = accesses.slice(0, partLength);
					this.accesses[1] = accesses.slice(partLength, partLength * 2);
					this.accesses[2] = accesses.slice(partLength * 2);

					let accessPublishers = _.map(_.keys(this.user?.options?.access?.publishers || {}), p => parseInt(p)).sort();
					partLength = Math.ceil(accessPublishers.length / 3);

					this.accessPublishers[0] = accessPublishers.slice(0, partLength);
					this.accessPublishers[1] = accessPublishers.slice(partLength, partLength * 2);
					this.accessPublishers[2] = accessPublishers.slice(partLength * 2);

					let accessCreatives = _.map(_.keys(this.user?.options?.access?.projects || {}), p => parseInt(p)).sort();
					partLength = Math.ceil(accessCreatives.length / 3);

					this.accessCreatives[0] = accessCreatives.slice(0, partLength);
					this.accessCreatives[1] = accessCreatives.slice(partLength, partLength * 2);
					this.accessCreatives[2] = accessCreatives.slice(partLength * 2);

				}

			},
			saveName(name) {

				Server.sendWithTimeout({
					UpdateUserName: {
						userId: this.user.id,
						name
					}
				});

			},
			replacePhoto() {

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "image/png, image/jpeg";

				input.addEventListener('change', e => {

					let file = e.target.files[0];

					let formData = new FormData();

					formData.append("userId", this.userId);
					formData.append("file", file);

					let url = 'http://' + SetupSettings["domain"] + '/user/uploadPhoto';
					if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + '/user/uploadPhoto';

					let xhr = new XMLHttpRequest();


					xhr.open("POST", url);
					Auth.authorizeRequest(xhr);

					xhr.upload.onprogress = function(e) {
						if (e.lengthComputable) {
							this.uploadProgress = e.loaded / e.total;
						}
					};

					xhr.upload.onloadstart = function(e) {
						this.isUploading = true;
					};

					xhr.upload.onloadend = function(e) {
						this.isUploading = false;
					};

					xhr.send(formData);

					document.body.removeChild(input);

				});

				input.click();

			},
			saveOption(optionsName, newData) {

				Server.sendWithTimeout({
					UpdateUserOptions: {
						userId: this.user.id,
						[optionsName]: newData
					}
				}, null, 1000);

			},
			activateUser(user, active) {

				Server.sendToSocket({
					SetUserStatus: {
						userId: user.id,
						active: active
					}
				})

			},
			deleteUser(user) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete user',
					message: `Are you sure you want to delete user "${user.name}"?<br>He will not be visible in any lists any more.`,
					confirmButtonText: '&nbsp;&nbsp;Delete user',
					confirmButtonIcon: 'fa-remove',
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteUser: this.user.id
						});
					}
				}])

			},
			deleteUserRevert(user) {

				Server.sendToSocket({
					DeleteUserRevert: this.user.id
				});

			},
			changePublisher(el, publisherId) {

				Broadcast.call('Show Confirm', [{
					caption: 'Change company',
					message: `Are you sure you want to change company for user "${this.user.name}" to "${Publisher.getPublisher(publisherId)?.title}"?`,
					confirmButtonText: '&nbsp;&nbsp;Change company',
					confirmButtonIcon: 'fa-exchange',
					confirmCallback: () => {

						Server.sendToSocket({
							ChangeUserPublisher: {
								userId: this.user.id,
								publisherId: parseInt(publisherId)
							}
						});

					},
					cancelCallback: () => {
						el.value = this.user['publisher_id']
					}
				}]);

			},
			changeRole(role) {

				Server.sendToSocket({
					ChangeUserRole: {
						userId: this.user.id,
						role: role
					}
				});

			},
			showAccess() {

				Broadcast.call('Show UserAccess', [this.user.id]);

			},
			// Окно ИИ настроек просматриваемого пользователя
			showUserAISettings() {

				Broadcast.call('Show UserSettingsAI', [this.user.id]);

			},
			// Окно обучения модели ключевых фраз для голосового ввода в ИИ чате
			showVoiceTraining() {

				Broadcast.call('Show AIAgentVoiceTraining');

			},
			changeAccessStatus(accessCodename, isChecked) {

				Server.sendToSocket({
					SetUserAccess: {
						userId: this.user.id,
						accessCodename: accessCodename,
						accessValue: isChecked
					}
				});

			},
			changeMraidioPublisherAccess(publisherAccess, isChecked) {

				Server.sendToServer({
					UpdateUserPublisherAccess: {
						userId: this.user.id,
						publisherId: publisherAccess.publisherId,
						grantAccess: isChecked
					}
				});

			},
			changeMraidioCreativeAccess(creativeId, isChecked) {

				Server.sendToServer({
					UpdateUserCreativeAccess: {
						userId: this.user.id,
						creativeId: creativeId,
						grantAccess: isChecked
					}
				});

			},
			loginUser() {

				Server.sendToSocket({
					LoginUser: {
						userId: this.user.id
					}
				});

			}
		}
	}
</script>

<style lang="sass" scoped>

	.user-profile
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: flex-start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

				.logo
					display: flex
					margin-left: auto
					padding: 10px

					img
						display: flex
						height: 33px
						margin: 0 10px
						align-items: center
						color: #fff
						padding-left: 10px
						text-transform: uppercase

			.settings-groups-area
				display: flex
				flex-direction: column
				flex-wrap: nowrap

				.settings-section
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					margin: 1rem
					margin-bottom: 0
					border-bottom: 1px solid rgba(0,0,0,0.2)
					padding-bottom: 1rem

					.settings-group
						padding: 0 1rem
						width: 50%

						.form-group
							margin-bottom: 0

						.form-group.user-name
							border-left: 1px solid rgba(0, 0, 0, 0.2)
							padding-left: 20px

					.settings-group.photo
						width: 66px
						padding: 0

				.settings-section.subcaption
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem

					> label
						margin-bottom: 20px

					> label.no-margin
						margin-bottom: 0

					.description
						margin-bottom: 20px

				.settings-section.access, .settings-section.publishers-access, .settings-section.creatives-access
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem

					> .description
						margin-bottom: 20px

					.column
						justify-content: start
						user-select: none

				.columns-3
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					width: 100%
					justify-content: space-between

					.column
						display: flex
						flex-direction: column
						width: 33%
						padding-right: 1rem
						justify-content: end

						.form-group
							display: flex
							flex-direction: column
							align-items: flex-start
							justify-content: flex-start

						.form-group.inline
							flex-direction: row
							align-items: center

						.form-group.no-margin
							margin-bottom: 0

				.columns-5
					display: flex
					flex-direction: row
					flex-wrap: nowrap
					width: 100%

					.column
						display: flex
						flex-direction: column
						width: 20%
						padding-right: 1rem

						.form-group
							display: flex
							flex-direction: column
							align-items: flex-start
							justify-content: flex-start

				.user-photo
					width: 64px
					height: 64px
					border-radius: 32px
					background: center/auto 100% no-repeat
					margin-right: 15px

				.detailed-log-button
					position: absolute
					right: 10px
					top: 3px

		label
			margin-bottom: 0.5rem

		input[type="text"]
			width: 100%
			height: calc(1.5em + 0.75rem + 2px)
			padding: 0.375rem 0.75rem
			font-size: 0.875rem
			font-weight: 400
			line-height: 1.5
			color: rgba(255, 255, 255, 0.87)
			background-color: rgba(255, 255, 255, 0.05)
			border: 1px solid rgba(255, 255, 255, 0.09)
			border-radius: 0.25rem
			transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out

		.multi-select-checkbox
			margin-bottom: 10px

			label
				margin-bottom: 0
				cursor: pointer

				.form-check-input
					top: -1px

				input
					cursor: pointer

		.custom-select
			width: auto

		.color-green
			color: var(--green)

	@media screen and (max-width: 600px)

		.publisher-settings

			.page-center-content

				.settings-groups-area

					.settings-group
						width: 100%

</style>

